import React from 'react';
import moment from 'moment-timezone';

const OPEN_STATUS = 'open';
const CLOSED_STATUS = 'closed';
const CLOSING_SOON_STATUS = 'closing_soon';

/**
 * Returns null if it's not today or no timezone is set, else Open or Closed.
 * Inspired on https://stackoverflow.com/a/59492313
 *
 * Assumes all hours[i].day are the same
 */
export default function CurrentlyOpenLabel({ hours, timezone }) {
  // Can't be totally sure without a timezone,
  // so don't do this if we don't have one.
  if (!timezone || hours.length === 0) {
    return null;
  }

  // If weekday isn't today.
  const now = moment.tz(timezone);
  const weekDayIso = now.isoWeekday();

  if (weekDayIso !== hours[0].day) {
    return null;
  }

  const allHourStatus = hours.map(hour => {
    const { open, close } = hour;
    const openTimeString = open.toString().padStart(4, '0');
    const openMoment = moment.tz(openTimeString, 'hmm', timezone);

    const closeTimeString = close.toString().padStart(4, '0');
    const closeMoment = moment.tz(closeTimeString, 'hmm', timezone);

    let hourStatus = CLOSED_STATUS;
    if (closeMoment.isBefore(openMoment) || openMoment.isSame(closeMoment)) {
      // Handle ranges that span over midnight
      if (now.isAfter(openMoment)) {
        hourStatus = OPEN_STATUS;
      }
    } else if (now.isBetween(openMoment, closeMoment, null, '[)')) {
      // Normal range check using an inclusive start time and exclusive end time
      hourStatus = OPEN_STATUS;
      if (closeMoment.diff(now, 'minutes') <= 15) {
        hourStatus = CLOSING_SOON_STATUS;
      }
    }
    return hourStatus;
  });

  if (allHourStatus.includes(OPEN_STATUS)) {
    return <span style={{ fontWeight: 'bold' }}>Open</span>;
  }

  if (allHourStatus.includes(CLOSING_SOON_STATUS)) {
    return <span style={{ fontWeight: 'bold' }}>Closing soon</span>;
  }

  return <span style={{ color: 'red' }}>Closed</span>;
}
